<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-02-14 14:35:17
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-07-06 09:40:37
 * @FilePath: \合联\oms\src\view\order\ttParcelForecast\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>
<script>
import {
  getList,
  update,
  upload,
  orders,
  weight,
} from "@/api/order/ttParcelForecast";
import cTable from "@/base/common/index";
import { getSelectType } from "@/api/public";
// import { getAllClient, getCompanies } from "@/api/user/client";
// import { getCurrency } from "@/api/finance/currency";
// import { getAgent } from "@/api/tracker/agent";
import { getAllClient } from "@/api/user/client";
import { getUser } from "@/api/user/internal";
import { getCountry } from "@/api/system/country";
// import { getChargingType } from "@/api/double/list";
// import { getConfig,getSubjectCost } from "@/api/tracker/cost_page";
import copyClick from "@/utils/copyClick";
export default {
  name: "mps",
  components: {
    cTable,
  },
  async created() {
    // let agentList = (await getAgent()).data.payload.rows
    const to_country = (await getCountry({ allow_arrive: 1 })).data.payload
      .rows;
    this.header.searchs.forEach(async (item) => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "to_country") item.options = to_country;
    });
    // this.modals.add.fields.forEach(t=>{
    // 	if(t.key === 'cod_agent')t.options = agentList
    // })
  },
  methods: {},
  data() {
    let that = this;
    return {
      list: [],
      status: [],
      statusObj: [],
      agentList: [],
      configs: {},
      client: [],
      companies: [],
      unit: [],
      bubble: [],
      currencyList: [],
      SubjectCost: [],
      methods: {
        getSelectType,
        list(params) {
          return getList(params);
        },
        update,
        upload,
        orders,
        weight,
      },
      modals: {
        weight: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ id: row.id });
              this.$page
                .handleRequestMethods("weight", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("重量"),
            modalBind: {
              width: 500,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              weight: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
            },
          },
          grid: [{ weight: 24 }],
          fields: [
            {
              name: this.$tz("重量"),
              key: "weight",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
          ],
        },
        details: {
          methods: {
            cancel: () => {
              this.list = [];
            },
          },
          config: {
            title: this.$t("childOrder"),
            modalBind: {
              width: 50,
              draggable: true,
            },
          },
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: () => this.$tz("TT,单号"),
                key: "airway_number",
                minWidth: 110,
                copy: true,
                header: {
                  copy: true,
                },
              },
              {
                name: () => this.$tz("CNT,单号"),
                key: "cnt_number",
                minWidth: 110,
                copy: true,
                header: {
                  copy: true,
                },
              },
            ],
          },
          footer: {
            show: () => false,
          },
        },
        files: {
          config: {
            modalBind: {
              width: 50,
              draggable: true,
            },
          },
          footer: {
            show: () => false,
          },
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: this.$t("file_name"),
                key: "name",
              },
              {
                name: this.$t("operation"),
                key: "src",
                width: 100,
                component: "Button",
                bind: {
                  size: "small",
                  type: "primary",
                },
                methods: {
                  render() {
                    return this.$t("show");
                  },
                  click({ row }) {
                    window.open(row.src);
                  },
                },
              },
            ],
          },
        },
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              data.airway_number = data.airway_number.split("\n");
              this.$page
                .handleRequestMethods("update", data, true)
                .then((e) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              styles: {
                top: "30px",
              },
              width: 700,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              status: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ status: 24 }, { airway_number: 24 }, { remarks: 24 }],
          fields: [
            {
              name: this.$t("order_number"),
              key: "airway_number",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("order_number"),
              bind: {
                type: "textarea",
                rows: 8,
              },
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 3,
              },
            },
            {
              key: "status",
              name: () => this.$t("tip"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("tip");
              },
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.status;
                },
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "dateType",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("select") + this.$t("time") + this.$t("type");
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["TIKTOK_PACKAGE_DATETYPE"]))
                  .data.payload["TIKTOK_PACKAGE_DATETYPE"];
                field.options = res;
                searchForm["dateType"] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
              // "on-change"({ searchForm }) {
              //   searchForm.startTime = searchForm.startTime
              //     ? this.$page.format.timeFormat(searchForm.startTime)
              //     : "";
              // }
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
              // "on-change"({ searchForm }) {
              //   let time = this.$page.format.timeFormat(searchForm.endTime);
              //   if (time.slice(-8) === "00:00:00") {
              //     time = time.split(" ")[0] + " " + "23:59:59";
              //     searchForm["endTime"] = time;
              //   }
              // }
            },
          },
          {
            key: "proof",
            placeholder() {
              return this.$tz("是否,举证");
            },
            component: "Select",
            options: [],
            optionsFn: "YesNoNumber",
            optionsKey: "",
          },
          {
            key: "keywordsType",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("keywords_type");
            },
            clearable: true,
            options: [],
            config: { label: ({ row }) => this.$t(row.label) },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["TIKTOK_PACKAGE_KEYWORDS"]))
                  .data.payload["TIKTOK_PACKAGE_KEYWORDS"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 2,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            // {
            //   name: () => this.$t("Update Status"),
            //   fnName: "updateStatus",
            //   type: "updateStatus",
            //   bind: {
            //     type: "primary",
            //   },
            // },
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            export({ searchForm }) {
              let data = JSON.parse(JSON.stringify(searchForm));
              data.export = 1;
              this.handleRequestMethods("list", data, true, true).then(
                (res) => {
                  window.open(this.$globalUrl + res.payload.src);
                }
              );
            },
            updateStatus() {
              this.getModal("add").open(
                {
                  airway_number: this.selectAll
                    .map((t) => t.airway_number)
                    .join("\n"),
                },
                function () {
                  this.setTitle(this.$t("Update Status"));
                }
              );
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
        },
        {
          name: this.$t("package_number"),
          key: "package_number",
          minWidth: 230,
          header: {
            copy: true,
          },
          copy: true,
          bind: {
            size: "small",
            type: "primary",
          },
          component: "Button",
          methods: {
            click: ({ row }) => {
              let table = this.$refs["table"];
              table.handleRequestMethods("orders", row.id).then((res) => {
                table.getModal("details").open(row, function () {
                  this.list = res.payload;
                });
              });
            },
          },
        },
        {
          name: this.$t("declaredWeight"),
          key: "package_weight",
          minWidth: 120,
        },
        {
          name: this.$t("orderNums"),
          key: "number",
          minWidth: 120,
        },
        {
          name: this.$tz("大包,入库数量"),
          key: "bag_number",
          minWidth: 120,
        },
        {
          name: () => this.$tz("入库时间"),
          key: "warehouse_time",
          minWidth: 110,
        },
        {
          name: this.$t("expectPickUpStartTime"),
          key: "expect_pickup_start_time",
          minWidth: 120,
        },
        {
          name: this.$t("expectPickUpEndTime"),
          key: "expect_pickup_end_time",
          minWidth: 120,
        },
        {
          name: this.$t("ReceiveTime"),
          key: "create_time",
          minWidth: 150,
        },
        {
          name: this.$tz("大包,重量"),
          key: "warehouse_weight",
          minWidth: 120,
        },
        {
          name: () => this.$tz("小包,汇总,重量"),
          key: "order_weight",
          minWidth: 110,
        },
        {
          name: this.$tz("未下单,数量"),
          key: "not_create",
          minWidth: 120,
        },
        {
          name: this.$t("alreadyInboundQuantity"),
          key: "in_warehouse",
          minWidth: 120,
        },
        {
          name: this.$t("NotInboundQuantity"),
          key: "not_warehouse",
          minWidth: 120,
        },
        {
          name: this.$t("evidenceFile"),
          key: "src",
          minWidth: 120,
          component: "Button",
          bind: {
            size: "small",
            type: "primary",
          },
          disabled: ({ row }) => !row.src.length,
          methods: {
            render() {
              return this.$t("show");
            },
            click({ row }) {
              this.$page.getModal("files").open(row, function () {
                this.setTitle(this.$t("evidenceFile"));
                this.list = row.src.map((t, i) => {
                  return {
                    name: t.replace(/\/.+\//, ""),
                    src: t,
                  };
                });
              });
            },
          },
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("UploadEvidenceFile"),
              type: "upload",
              fnName: "upload",
              bind: {
                type: "success",
              },
              // id:1258
            },
            {
              name: () => this.$tz("重量"),
              type: "weight",
              fnName: "weight",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            weight({ row }) {
              this.getModal("weight").open({ id: row.id }, function () {
                this.setTitle(this.$tz("重量"));
              });
            },
            upload({ row }) {
              let el = document.createElement("input");
              el.type = "file";
              el.multiple = true;
              el.click();
              el.addEventListener("input", (e) => {
                let formData = new FormData();
                Object.values(el.files).forEach((file) => {
                  formData.append("file[]", file);
                });
                this.handleRequestMethods(
                  "upload",
                  { data: formData, id: row.id },
                  true,
                  true
                ).then((res) => {
                  this.getList();
                });
              });
            },
          },
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped></style>
